import { ExclamationTriangleColored } from '@assets/svgs';
import { Box } from '@mui/material';

export const DeprecatedIcon = ({ iconStyle }: { iconStyle?: React.CSSProperties }) => {
  return (
    <Box component='span' sx={{ height: 0, width: '16px' }}>
      <ExclamationTriangleColored
        color='warning.main'
        style={{
          position: 'relative',
          top: '4px',
          height: '16px',
          width: '16px',
          color: 'error.main',
          margin: 0,
          marginRight: '2px',
          ...iconStyle,
        }}
      />
    </Box>
  );
};
